import { createActionGroup, props } from '@ngrx/store';

export const PoiPadResultComponentActions = createActionGroup({
  source: 'Pad Result Component',
  events: {
    Initialized: props<{ payload: string }>(),
  },
});
